module.exports = "/_next/static/images/79607c1971bdbb7b09042d040922a0b3-woman-with-iphone-short-form@0.5x.jpg.webp";